import React from "react";
import { projects } from "./Constants";
import Reveal from "./Reveal";
import { FiGithub } from "react-icons/fi";
import { GoLink } from "react-icons/go";

const Projects = () => {
  return (
    <div id="projects" className="w-full relative">
      <div className="flex flex-col justify-center w-full h-full max-w-screen-lg p-4 mx-auto ">
        <div className="pb-8  mt-16 fadein">
          <Reveal slidePermission={false}>
            <p className="inline p-2 text-4xl font-bold text-white border-b4 border-gray500 ">
              Projects
            </p>
          </Reveal>
          <Reveal slidePermission={false}>
            <p className="py-1 px-2  text-gray-500 ">
              Check out some of my work right here
            </p>
          </Reveal>
        </div>
        <div className="grid grid-cols-1 gap-8 px-0 md:px-4">
          {projects.map(
            (
              { id, name, src, demo, code, desc, skills, skillsIcon },
              index
            ) => (
              <Reveal key={id} slidePermission={false}>
                <div
                  className={`flex gap-4 ${
                    index % 2 === 1 ? "flex-row-reverse" : "flex-row"
                  }`}
                >
                  <div
                    className="bg-gradient-to-br from-[#100924] via-[#140a23] to-[#160530]
                rounded-lg cursor-pointer p-4 md:p-5
                 duration-300 w-full"
                  >
                    <h2 className="text-[18px] md:text-[22px] text-white font-semibold">
                      {name}
                    </h2>
                    <p className="text-[#CCD6F6] sm:text-[14px] text-[13px] mt-3 !font-normal">
                      {desc}
                    </p>

                    <div className="flex items-center mt-8 gap-2 text-sm text-[#CCD6F6] py-1">
                      Tools:
                      <div className="flex gap-2">
                        {skillsIcon.map((Icon, skillIndex) => (
                          <div
                            key={skillIndex}
                            className="tooltipContainer relative inline-flex items-center justify-center w-[28px] h-[28px] flex-none"
                          >
                            <Icon size={25} className="text-[#6330A0]" />
                            <div className="tooltipBox">
                              {skills[skillIndex]}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="my-2 flex gap-4 justify-between">
                      <a
                        href={demo}
                        target="_blank"
                        rel="noreferrer"
                        className="group flex h-8 items-center gap-2 rounded-full bg-[#190734] sm:pl-3 sm:pr-4 pl-2 pr-3 transition-all duration-300 ease-in-out hover:bg-[#6330A0]  hover:pl-2 hover:text-white text-[#CCD6F6] !font-normal sm:text-[11px] text-[10px]"
                      >
                        <span className="rounded-full bg-[#CCD6F6] p-1 text-sm transition-colors duration-300 group-hover:bg-white">
                          <svg
                            stroke="currentColor"
                            fill="none"
                            strokeWidth={2}
                            viewBox="0 0 24 24"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="-translate-x-[200%] text-[0px] transition-all duration-300 group-hover:translate-x-0 group-hover:text-sm group-hover:text-black -rotate-45"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                            <polyline points="12 5 19 12 12 19"></polyline>
                          </svg>
                        </span>
                        <span>View Project</span>
                      </a>
                      <div className="flex sm:gap-4 gap-2 sm:text-[11px] text-[10px] text-[#CCD6F6] ">
                        <a
                          href={code}
                          target="_blank"
                          rel="noreferrer"
                          className="flex items-center gap-1 hover:text-[#6330A0]"
                        >
                          <FiGithub /> Repository
                        </a>
                        <a
                          href={demo}
                          target="_blank"
                          rel="noreferrer"
                          className="flex items-center gap-1 hover:text-[#6330A0]"
                        >
                          <GoLink /> Open Live Site
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="!bg-[#140a23]  rounded-lg cursor-pointer p-2 hover:scale105 duration-300 w-[40%]  justify-center md:flex hidden">
                    <img
                      src={src}
                      alt={name}
                      className="rounded-md select-none  object-cover"
                      loading="lazy"
                    />
                  </div>
                </div>
              </Reveal>
            )
          )}
        </div>

        {/* <div className="grid grid-cols-1 gap-8 px-0 md:px-4 md:grid-cols-2 lg:grid-cols-2">
          {projects.map(({ id, name, src, demo, code, desc }) => (
            <Reveal slidePermission={false}>
              <div
                key={id}
                className="p-2 duration-500 rounded-lg  cursor-pointer md:p-5  dark:!bg-[#404040] !bg-[#150f28]  hover:scale105 fadein"
              >
                <Reveal slidePermission={true}>
                  <h2 className="text-base font-semibold text-[#CCD6F6] md:text-xl">
                    {name}
                  </h2>
                </Reveal>
                <div className="flex items-center justify-center py-3">
                  <img
                    src={src}
                    alt=""
                    className="md:h-[150px] h-[150px] sm:w-[300px] w-[250px] roundedmd  rounded-sm  select-none"
                    loading="lazy"
                  />
                </div>
                <div>
                  <Reveal slidePermission={false}>
                    <p className="text-sm text-[#CCD6F6] md:text-base h-[90px]">
                      {desc}
                    </p>
                  </Reveal>
                </div>
                <div className="flex items-center justify-center">
                  <a
                    href={demo}
                    rel="noreferrer"
                    className="flex justify-between w-full text-[#9857D3] item-center "
                    target="_blank"
                  >
                    <button className="w-1/2 m-4 duration-200 hover:scale-105">
                      Demo
                    </button>
                  </a>

                  <a
                    href={code}
                    rel="noreferrer"
                    className="flex justify-between w-full text-[#9857D3] item-center"
                    target="_blank"
                  >
                    <button className="w-1/2 m-4 duration-200 hover:scale-105">
                      Code
                    </button>
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div> */}
      </div>
      <div className="w-[200px] h-[500px] bg-[#6330A0] blur-[200px] !absolute bottom-0 left-0 z-[0px] md:block hidden"></div>
    </div>
  );
};

export default Projects;
